import { cn } from '@/lib/utils';

import type { ApiOperation } from './operations';

/**
 * The HTTP method, at a fixed width.
 *
 * Not a `BadgeCell`: these sit in a column a hundred rows deep and are read by
 * shape as much as by word, so DELETE and GET have to occupy the same space or
 * the paths beside them stop lining up.
 */
const METHOD_TONES: Readonly<Record<ApiOperation['method'], string>> = {
  get: 'bg-info-bg text-info-fg',
  post: 'bg-ok-bg text-ok-fg',
  put: 'bg-warn-bg text-warn-fg',
  patch: 'bg-warn-bg text-warn-fg',
  delete: 'bg-err-bg text-err-fg',
};

export function MethodChip({
  method,
  className,
}: {
  readonly method: ApiOperation['method'];
  readonly className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex h-5 w-14 shrink-0 items-center justify-center rounded-[10px] font-mono text-[11.5px] font-semibold uppercase',
        METHOD_TONES[method],
        className,
      )}
    >
      {method}
    </span>
  );
}
